import React, { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { IconPlus, IconUser } from "@tabler/icons-react";
import { LangConstant, SystemConstant } from "const";
import { useCreateBotMessage, useBotMessageList } from "hooks";
import { SystemUtils, CommonUtils } from "utils";
import { PageTitle } from "components";
import { CreateMessageDialog, Datatable, BotAccountDialog } from "./components";

const MediaManagement = () => {
  const { t: getLabel } = useTranslation();
  const titleObjectContent = getLabel(LangConstant.OBJ_SIDEBAR_TITLE, { returnObjects: true });

  const { createBotMessage } = useCreateBotMessage();

  const [actionDialogConfig, setActionDialogConfig] = useState({ open: false, position: null });
  const [isOpenBotAccount, setIsOpenBotAccount] = useState(false);
  const [page, setPage] = useState(1);

  const { botMessageList, pagination, refetch, isFetching } = useBotMessageList({
    page: page,
  });

  const onChangePage = (e, page) => {
    setPage(page);
  };

  const handleCloseActionDialog = () => {
    setActionDialogConfig({ open: false, position: null });
  };

  const handleCreateMessage = (content, time) => {
    if (!Boolean(content)) {
      SystemUtils.appendNotification(getLabel(LangConstant.TXT_MEDIA_CONTENT_EMPTY), "error");
    } else {
      createBotMessage({
        content: content,
        time: time,
        onClose: async () => {
          if (time === 0) {
            SystemUtils.appendNotification(getLabel(LangConstant.TXT_MEDIA_SEND_SUCCESS), "success");
          } else {
            SystemUtils.appendNotification(getLabel(LangConstant.TXT_MEDIA_SCHEDULE_SUCCESS), "success");
          }
          handleCloseActionDialog();
          refetch();
        },
      });
    }
  };

  const handleDraftMessage = content => {
    if (!Boolean(content)) {
      SystemUtils.appendNotification(getLabel(LangConstant.TXT_MEDIA_CONTENT_EMPTY), "error");
    } else {
      createBotMessage({
        content: content,
        onClose: () => {
          handleCloseActionDialog();
          refetch();
          SystemUtils.appendNotification(getLabel(LangConstant.TXT_MEDIA_DRAFT_SAVED), "success");
        },
      });
    }
  };

  const handleOpenCreateMessageDialog = () => {
    setActionDialogConfig({ open: true, position: null });
  };

  return (
    <Fragment>
      <PageTitle>{getLabel(titleObjectContent.mediaManagement)}</PageTitle>
      <div className="card">
        <div className="card-body" style={{ padding: "20px 16px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <span style={{ fontSize: "20px" }}>{getLabel(LangConstant.TXT_MEDIA_MESSAGE_LIST)}</span>
            <div style={{ display: "flex", gap: "8px" }}>
              <button
                className="btn btn-primary"
                style={{ height: "40px" }}
                onClick={() => {
                  setIsOpenBotAccount(true);
                }}
              >
                <IconUser size={16} style={{ marginRight: "4px" }} />
                {getLabel(LangConstant.TXT_MEDIA_ACCOUNT_INFO)}
              </button>
              <button
                className="btn btn-primary"
                style={{ height: "40px" }}
                onClick={handleOpenCreateMessageDialog}
              >
                <IconPlus size={16} style={{ marginRight: "4px" }} />
                {getLabel(LangConstant.TXT_MEDIA_COMPOSE_NEW)}
              </button>
            </div>
          </div>

          <Datatable
            botMessageList={botMessageList}
            pagination={pagination}
            onChangePage={onChangePage}
            isLoading={isFetching}
            refetch={refetch}
          />

          <CreateMessageDialog
            open={actionDialogConfig.open}
            onClose={handleCloseActionDialog}
            onCreate={handleCreateMessage}
            onDraft={handleDraftMessage}
          />

          <BotAccountDialog
            open={isOpenBotAccount}
            onClose={() => {
              setIsOpenBotAccount(false);
            }}
          />
        </div>
      </div>
    </Fragment>
  );
};

export default MediaManagement;
